import React from 'react'
import {injectIntl} from 'react-intl'
import Button from '@mui/material/Button'
import Notification from './Notification'

const Notifications = ({intl, emissions, notifications, entity, substitutions, forms, fields,
    dates, numbers, handleCreate, handleDelete, handleUpdate}) => {

    return (
        <React.Fragment>
            {emissions && !emissions.length &&
                intl.formatMessage({id: 'sidebar.has_no_emissions'})
            }
            {notifications && !!notifications.length &&
                <div>
                    {notifications.map((item, index) =>
                        <Notification
                            key={item.id}
                            index={index}
                            template={item}
                            entity={entity}
                            emissions={emissions}
                            handleDelete={handleDelete}
                            handleUpdate={handleUpdate}
                            substitutions={substitutions}
                            forms={forms}
                            fields={fields}
                            dates={dates}
                            numbers={numbers}
                        />
                    )}
                </div>
            }
            {emissions && !!emissions.length &&
                <Button
                    variant="contained"
                    onClick={handleCreate}
                    style={{background: '#4cae4c', color: '#fff'}}
                >
                    {intl.formatMessage({id: 'sidebar.add_notification'})}
                </Button>
            }
        </React.Fragment>
    )
}

export default injectIntl(Notifications)
